import { render } from "./Reddit.vue?vue&type=template&id=3597f61a"
import script from "./Reddit.vue?vue&type=script&lang=js"
export * from "./Reddit.vue?vue&type=script&lang=js"
script.render = render

export default script